import { render } from "./StafetRoundCounterAccordion.vue?vue&type=template&id=6688c272"
import script from "./StafetRoundCounterAccordion.vue?vue&type=script&lang=js"
export * from "./StafetRoundCounterAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__